// extracted by mini-css-extract-plugin
export var articlelist = "postsGrid-module--articlelist--1KFlZ";
export var listitem = "postsGrid-module--listitem--1Niwe";
export var article__content = "postsGrid-module--article__content--2IHR3";
export var articlesGrid = "postsGrid-module--articles-grid--KuwfL";
export var imageWrapper = "postsGrid-module--image-wrapper--3-hiD";
export var pinImage = "postsGrid-module--pin-image--Nc8ka";
export var pinImageMeta = "postsGrid-module--pin-image-meta--2Y2R4";
export var excerpt = "postsGrid-module--excerpt--2R2_L";
export var readMore = "postsGrid-module--read-more--pZFDu";